//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import { IUrlRouterProvider } from 'angular-ui-router';

import {
  NavGroup,
  componentNameToTemplate,
  hasFeature,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

export function routingRules(urlRouterProvider: IUrlRouterProvider) {
  // TODO: PD-287228 - Need to clarify custom reporting feature availability:
  // - Will this be available to all clients or specific packages?
  // - Do we need to add feature flag checks?
  const isCustomReportingEnabled = hasFeature(FeatureNames.CustomReporting);

  if (!isCustomReportingEnabled) {
    urlRouterProvider.when(
      /\/insights\/custom-reporting(\/.*)?$/,
      '/insights/summary',
    );
  }
}

export const states = {
  'custom-reporting': {
    url: '/custom-reporting/:reportId?dateRange',
    template: componentNameToTemplate('customReportingPage'),
    resolve: {
      ...lazyLoadModule(
        'curalate.customReporting',
        () => import('@insights/CustomReportingApp'),
      ),
    },
    data: {
      title: 'Custom Reporting',
      navGroup: NavGroup.INSIGHTS,
      // TODO: PD-287228 - Need to clarify custom reporting feature availability:
      // - Will this be available to all clients or specific packages?
      // - Do we need to add feature flag checks?
      hasAccess: () => hasFeature(FeatureNames.CustomReporting),
    },
  },
};
